import React from "react";

import { searchStructuralUnits } from "@/api/one_c_pickers";
import { LoadState } from "@/lib/scan-ui/screen";
import { OrgWhitelistCard } from "@/pages/settings/cards/OrgWhitelistCard";
import { SettingsPageHeader } from "@/pages/settings/SettingsPageHeader";
import { useSystemSettingsQuery } from "@/pages/settings/useSystemSettingsQuery";

const SUBTITLE = "Юрлица и склады, между которыми перемещают запасы без заказа.";

// Пустой список здесь — НЕ «все»: раздел честно пишет «не настроено» и
// создать перемещение не даёт (бэкенд — 422). Подпись карточки обязана
// говорить то же, иначе админ «сбросит» список, думая, что открыл всё.
const EMPTY_HINT_ORGS =
  "Отметьте юрлица, от имени которых делают перемещения. Пока ничего не отмечено — раздел не работает.";
const EMPTY_HINT_WHS =
  "Отметьте склады — из этого списка выбирают и отправителя, и получателя. Нужно минимум два; пока ничего не отмечено — раздел не работает.";

/** Настройки раздела «Перемещение»: юрлица и склады. */
export function StockTransferSettingsPage(): React.ReactElement {
  const { data, isLoading, error, refetch } = useSystemSettingsQuery();

  if (isLoading || error || !data) {
    return (
      <div className="mx-auto max-w-2xl space-y-6">
        <SettingsPageHeader title="Перемещение" subtitle={SUBTITLE} />
        <LoadState
          isLoading={isLoading}
          error={error}
          onRetry={() => void refetch()}
          className="flex flex-col items-center gap-3 p-4 text-center"
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <SettingsPageHeader title="Перемещение" subtitle={SUBTITLE} />
      <OrgWhitelistCard
        title="Юрлица в разделе «Перемещение»"
        field="stock_transfer_org_refs"
        current={data.stock_transfer_org_refs}
        hint={EMPTY_HINT_ORGS}
        emptyLabel="не настроено"
      />
      <OrgWhitelistCard
        title="Склады раздела «Перемещение»"
        field="stock_transfer_warehouse_refs"
        current={data.stock_transfer_warehouse_refs}
        searchFn={(q) => searchStructuralUnits("Склад", q)}
        queryKey="stock-transfer-warehouses-all"
        entityLabel="склады"
        hint={EMPTY_HINT_WHS}
        emptyLabel="не настроено"
      />
    </div>
  );
}
